import { logEvent } from '@mfs/client/common/log-ga-event/logGaEvent'

export const handleClick = (e) => {
  handleGa4Click()
  openLoginModal(e)
}

const openLoginModal = (e) => {
  e?.stopPropagation()
  if (window?.PCLN) {
    window.PCLN.pclnEventDispatcher.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL')
  }
}
const handleGa4Click = () => {
  logEvent('internal_click', {
    type: 'VIP_banner',
    link_name: 'vip_sign_in',
    link_text: 'sign_in',
    page_name: 'listings',
    link_item: 'air',
    product_name: 'bundle',
  })
}

export const handleComponentLoaded = (isSignedIn) => {
  logEvent('display', {
    type: isSignedIn ? 'new_vip_signed_in_banner' : 'new_vip_signed_out_banner',
    page_name: 'listings',
    product_name: 'bundle',
    item_name: 'air_listings',
  })
}
